'use client';

import { useEffect } from 'react';
import { useConnectionQuality } from '@/hooks';

interface Props {
  serverSaveData: boolean;
  serverTimestamp: string;
}

export function ConnectionQualityDebugClient({ serverSaveData, serverTimestamp }: Props) {
  const client = useConnectionQuality();

  useEffect(() => {
    console.log('[ConnectionQuality] server', { saveData: serverSaveData, at: serverTimestamp });
    console.log('[ConnectionQuality] client', client);
  }, [client, serverSaveData, serverTimestamp]);

  return null;
}
